"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledUpdatedLabelWrapper = exports.StyledWrapper = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledWrapper = styled_components_1.default.div `
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  align-items: center;
  height: 100%;  

  .MuiTypography-body2 {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
exports.StyledUpdatedLabelWrapper = styled_components_1.default.div `
  display: flex;
  padding: ${({ theme }) => theme.spacing(0.5, 1)};
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  border: 1px solid ${ui_components_1.baseColors.border};
  background-color: ${ui_components_1.baseColors.blue300};

  .MuiTypography-body2 {
    color: ${ui_components_1.baseColors.white};
    font-size: 0.75rem;
    line-height: 1;
  }
`;
